export default __webpack_public_path__ + "static/media/GOLD CLASS_2.25ae356a.jpg";